import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={14}
    height={15}
    viewBox="0 0 15 15"
    fill={props.fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 0.5C3.13895 0.5 0 3.63895 0 7.5C0 11.3611 3.13895 14.5 7 14.5C10.8611 14.5 14 11.3611 14 7.5C14 3.63895 10.8611 0.5 7 0.5ZM1.54737 7.5C1.54737 6.27684 1.96 5.14205 2.63792 4.22842L10.2716 11.8621C9.35795 12.5547 8.22318 12.9527 7.00003 12.9527C3.99371 12.9527 1.54739 10.5063 1.54739 7.50003L1.54737 7.5ZM11.3621 10.7716L3.72842 3.13789C4.64208 2.44537 5.77684 2.04742 7 2.04742C10.0063 2.04742 12.4526 4.49376 12.4526 7.50005C12.4526 8.72321 12.0547 9.858 11.3622 10.7716L11.3621 10.7716Z"
      fill={props.fill}
    />
  </svg>
);
export default SVGComponent;
